export default "__VITE_ASSET__DXDeJsG6__"